<template>
    <div class="addCommentContainer">
        <div class="commentAttachmentDropArea droparea" @drop="onDrop">
            Rilascia qui per allegare
        </div>
        <auto-textarea class="form-control" placeholder="Scrivi qui" v-model="localValue.text" :maxHeight="150"></auto-textarea>
        <label class="btn btn-link">
            <icon-clip></icon-clip>
            <file-input class="hidden" v-model="tempFile" @update:modelValue="addFile"></file-input>
        </label>
        <slot>
            <button type="button" class="btn btn-success" :disabled="!canSaveComment" @click="addComment">
                <icon-send></icon-send>
            </button>
        </slot>
    </div>
    <div class="addCommentAttachment" v-if="localValue.fileList.length > 0">
        <div v-for="item in localValue.fileList" :key="item.name">
            Allegato: {{item.name}}
            <button type="button" class="btn btn-danger btn-sm" @click="removeFile(item)">
                x
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import * as OM from '@/model';
import { JsonClone } from '@/utils';
import * as VM from '@/viewmodel';
import { mixins, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    emits: {
        add: ""
    }
})
export default class newCommentForm extends mixins(WithModel) {

    declare localValue: VM.AddCommentVm;

    tempFile: File = null;

    onDrop(ev){
        this.tempFile = ev.dataTransfer.files[0];
        this.addFile();
    }

    addComment(){
        if(!this.canSaveComment)
            return;

        this.$emit('add', this.localValue);

        this.localValue = new VM.AddCommentVm();
        this.localValue.text = '';
    }

    addFile(){
        this.localValue.fileList.push(this.tempFile);
        this.tempFile = null;
    }

    removeFile(item: File){
        let index = this.localValue.fileList.findIndex(x => x == item);
        this.localValue.fileList.splice(index, 1);
    }
    
    get canSaveComment(){
        return this.localValue.text || this.localValue.fileList.length > 0;
    }

}

</script>

<style scoped>

.hidden {
    left: 0;
}

.addCommentContainer {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 6px 10px;
    background: #fff;
    transition: border-color 0.15s;
}

.addCommentContainer:focus-within {
    border-color: #029394;
    box-shadow: 0 0 0 3px rgba(2, 147, 148, 0.12);
}

.addCommentContainer :deep(.form-control) {
    border: none;
    box-shadow: none;
    padding: 4px 0;
    flex: 1;
    background: transparent;
}

.addCommentContainer :deep(.form-control:focus) {
    outline: none;
    box-shadow: none;
}

.commentAttachmentDropArea {
    font-size: 0.75rem;
    color: #adb5bd;
    border: 1px dashed #dee2e6;
    border-radius: 4px;
    padding: 4px 8px;
    text-align: center;
    margin-bottom: 6px;
}

.addCommentAttachment {
    font-size: 0.8rem;
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.addCommentAttachment > div {
    background: #e9ecef;
    border-radius: 4px;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

</style>